import { hasEmoji, hasSpecialCharacters } from "./stringValidityCheck";

interface NameValidityResult {
  isValid: boolean;
  message: string;
}

export function checkNameValidity(name: string): NameValidityResult {
  let message = "";
  let isValid = true;

  if (name.length === 0) {
    isValid = false;
  }

  if (name.length === 1) {
    message = "Name needs to be at least 2 characters";
    isValid = false;
  }

  if (hasEmoji(name) || hasSpecialCharacters(name)) {
    message = "Name cannot contain emojis or special characters";
    isValid = false;
  }

  return {
    isValid,
    message,
  };
}
